var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.isPC)?_c('SignInPC',{attrs:{"isBView":_vm.isBView}}):_c('SignInH5',{attrs:{"isBView":_vm.isBView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }